module.exports = __webpack_public_path__ + "VPAIDFlash.swf";


//////////////////
// WEBPACK FOOTER
// ./~/vpaid-flash-client/bin/VPAIDFlash.swf
// module id = 49
// module chunks = 0 1 2 3